import { render, staticRenderFns } from "./InflationCalculator.vue?vue&type=template&id=42a997d0&scoped=true&"
import script from "./InflationCalculator.vue?vue&type=script&lang=js&"
export * from "./InflationCalculator.vue?vue&type=script&lang=js&"
import style0 from "./InflationCalculator.vue?vue&type=style&index=0&id=42a997d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a997d0",
  null
  
)

export default component.exports